/**
 * Fogarty's slow text-response feedback, matching production main.js:
 * wait 5s for the first token, type each line at 30ms/character, pause 1s.
 * Reuses the transient typing row; nothing enters conversation history.
 */
import { on } from "../../core/state.js";
import pouringGif from "./assets/waiting-animation.gif";

const LINES = [
  "We are aging our response to perfection",
  "Hold tight!. We are uncorking the perfect response",
  "Pouring you the perfect answer",
];

export function initWaitingResponse(shadow) {
  if (!shadow) return;
  let timer;
  let content;

  const stop = () => {
    clearTimeout(timer);
    content?.remove();
    content = null;
  };

  const show = () => {
    const bubble = shadow.querySelector(".ws-typing-row .ws-typing");
    if (!bubble) return;
    content = document.createElement("div");
    content.className = "ws-fogarty-waiting";
    const text = document.createElement("p");
    const image = document.createElement("img");
    image.src = pouringGif;
    image.alt = "";
    content.append(text, image);
    bubble.replaceChildren(content);

    const type = (line, character) => {
      if (!content?.isConnected) return;
      text.textContent = LINES[line].slice(0, character + 1);
      if (character < LINES[line].length) {
        timer = setTimeout(() => type(line, character + 1), 30);
      } else if (line < LINES.length - 1) {
        timer = setTimeout(() => type(line + 1, 0), 1000);
      }
    };
    type(0, 0);
  };

  on("ws-chat-stream-waiting", ({ active }) => {
    stop();
    if (active) timer = setTimeout(show, 5000);
  });
  on("ws-chat-typing", ({ active }) => { if (!active) stop(); });
  on("ws-messages-cleared", stop);
}
